import { Injectable } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class CustomDatePickerTranslateService extends NgbDatepickerI18n {

  private locale: string;
 
  constructor(private translationService: TranslateService) {
    super();
    this.translationService.onLangChange.subscribe(locale => {
      this.locale = locale.lang === 'en' ? 'en-GB' : 'it-IT' ;
    });
  }

  getMonthShortName(month: number): string {
    return new Intl.DateTimeFormat(this.locale, { month: 'short' }).format(new Date(0, month - 1));
  }

  getWeekdayShortName(weekday: number): string {
    return new Intl.DateTimeFormat(this.locale, { weekday: 'short' }).format(new Date(2023, 0, weekday));
  }

  getMonthFullName(month: number): string {
    return new Intl.DateTimeFormat(this.locale, { month: 'long' }).format(new Date(0, month - 1));
  }

  getWeekdayLabel(weekday: number): string {
    return new Intl.DateTimeFormat(this.locale, { weekday: 'short' }).format(new Date(2023, 0, weekday));
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }
}
